<template>
    <Transition name="fade">
        <div v-if="visible" class="event-notify" :class="notifyClass">
            +{{ count }} 事件
        </div>
    </Transition>
</template>

<script>
import { eventBus } from '@shared/stores/globalState';
import eventService from '@shared/services/event';

export default {
    name: 'EventCacheSync',

    data() {
        return {
            visible: false,
            count: 0,
            isNew: false, // true = Realtime 新事件, false = 同步舊資料
            hideTimer: null,
            eventListener: null
        };
    },

    computed: {
        notifyClass() {
            return this.isNew ? 'notify-new' : 'notify-sync';
        }
    },

    mounted() {
        // 監聯 eventBus 同步事件
        eventBus.on('eventService:syncComplete', this.handleSyncComplete);

        // 監聽 EventService 的 Realtime 事件
        this.eventListener = (eventType, data) => {
            if (eventType === 'event:added' || eventType === 'event:mqtt') {
                this.showNotify(1, true);
            }
        };
        eventService?.addEventListener(this.eventListener);
    },

    beforeUnmount() {
        eventBus.off('eventService:syncComplete', this.handleSyncComplete);
        if (this.eventListener) {
            eventService?.removeEventListener(this.eventListener);
        }
        if (this.hideTimer) {
            clearTimeout(this.hideTimer);
        }
    },

    methods: {
        handleSyncComplete({ newCount, updatedCount }) {
            const total = (newCount || 0) + (updatedCount || 0);
            if (total > 0) {
                this.showNotify(total, false);
            }
        },

        showNotify(count, isNew) {
            this.count = count;
            this.isNew = isNew;
            this.visible = true;
            this.scheduleHide();
        },

        scheduleHide(delay = 1500) {
            if (this.hideTimer) {
                clearTimeout(this.hideTimer);
            }
            this.hideTimer = setTimeout(() => {
                this.visible = false;
            }, delay);
        }
    }
};
</script>

<style scoped lang="stylus">
.event-notify
    position fixed
    bottom 0
    right 20px
    z-index 900
    display flex
    align-items center
    padding 5px 12px
    border-radius 8px 8px 0 0
    font-size 12px
    box-shadow 0 2px 12px rgba(0, 0, 0, 0.15)

    // 同步舊資料 - 灰底
    &.notify-sync
        background rgba(140, 140, 140, 0.9)
        color #fff

    // Realtime 新事件 - 藍底
    &.notify-new
        background rgba(64, 158, 255, 0.95)
        color #fff

// 淡入淡出動畫
.fade-enter-active
.fade-leave-active
    transition opacity 0.3s ease, transform 0.3s ease

.fade-enter-from
.fade-leave-to
    opacity 0
    transform translateY(10px)

// 深色模式
body.dark-theme
    .event-notify
        box-shadow 0 2px 12px rgba(0, 0, 0, 0.4)

        &.notify-sync
            background rgba(100, 100, 100, 0.9)

        &.notify-new
            background rgba(64, 158, 255, 0.9)
</style>
